import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Skip from './skip-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Skip {...validProps} />;
}
SvgComponent.iconName = 'skip';

export const SkipIcon = svgIconWrapper(SvgComponent);
